const ACCEPTED_RELAY_STATES = new Set(["disabled", "starting", "active"]);

// A 200 response only means the relay request was handled. Transient states
// such as waiting_for_publisher still need to be retried by the creator.
export const isRelayAnnouncementAccepted = (relayResult) => {
  if (relayResult?.started === true) return true;

  const state = String(relayResult?.state || "").trim().toLowerCase();
  return ACCEPTED_RELAY_STATES.has(state);
};

